import { gql } from "@apollo/client";

export const GET_LOCALIDADES = gql`
    query GetLocalidades($idProvincia: Int!) {
        localidades(idProvincia: $idProvincia) {
            success
            error
            valorEsperado {
                idLocalidad
                descripcion
            }
        }
    }
`;

export const adaptLocalidadesArray = (localidades) => {
  return localidades?.map((localidad) => ({
    id: localidad.idLocalidad,
    displayName: localidad.descripcion
  }));
};